import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const useSidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  
  const isExpenseActive = location.pathname === '/expense' ||
                          location.pathname.startsWith('/expense/manager') ||
                          location.pathname.startsWith('/expense/automated-tracker') ||
                          location.pathname.startsWith('/expense/credit-cards') ||
                          location.pathname.startsWith('/expense/bank-accounts') ||
                          location.pathname.startsWith('/expense/vaults') ||
                          location.pathname.startsWith('/expense/banks') ||
                          location.pathname.startsWith('/expense/budgets') ||
                          location.pathname.startsWith('/expense/entities');

  const [isExpenseOpen, setIsExpenseOpen] = useState(isExpenseActive);

  useEffect(() => {
    setIsExpenseOpen(isExpenseActive);
  }, [isExpenseActive]);

  return {
    t,
    isExpenseActive,
    isExpenseOpen,
    setIsExpenseOpen
  };
};
